import angular from 'angular';

if (!Array.prototype.clear) {
  Array.prototype.clear = function() {
    if (this == null) throw new TypeError('Array.prototype.clear called on null or undefined');

    //Clear array without losing reference
    while (this.length > 0) this.pop();
  };
}

if (!Array.prototype.unique) {
  Array.prototype.unique = function() {
    var a = this.concat();
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }

    return a;
  };
}

if (!Array.prototype.sortByProperty) {
  Array.prototype.sortByProperty = function(property) {
    if (!property) return this.sort();
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return this.sort(function(a, b) {
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    });
  };
}
const isGuid = function(value) {
  if (value == null || typeof value !== 'string' || value.length < 36) return false;
  return /^\{?[a-fA-F0-9]{8}-([a-fA-F0-9]{4}-){3}[a-fA-F0-9]{12}\}?$/.test(value);
};

if (!window.isGuid) {
  window.isGuid = isGuid;
}

if (!String.prototype.addParam) {
  String.prototype.addParam = function(param, value) {
    var a = document.createElement('a'),
      regex = /(?:\?|&amp;|&)+([^=]+)(?:=([^&]*))*/g;
    var match,
      str = [];
    a.href = this;
    param = encodeURIComponent(param);
    while ((match = regex.exec(a.search)))
      if (param !== match[1]) str.push(match[1] + (match[2] ? '=' + match[2] : ''));
    str.push(param + (value ? '=' + encodeURIComponent(value) : ''));
    a.search = str.join('&');
    return a.href;
  };
}

Number.prototype.toTime = function() {
  var totalMinutes = Math.round(this * 60);
  return totalMinutes.minuteToTime();
};
Number.prototype.minuteToTime = function() {
  var sign = this < 0 ? '-' : '';
  var h = Math.floor(Math.abs(this) / 60);
  var m = Math.abs(this) % 60;
  return sign + h + ':' + (m < 10 ? '0' : '') + m;
};

Number.prototype.getFractionSize = function() {
  var s = this.toString();
  if (s.indexOf('.') < 0) return 0;
  var n = 0;

  for (var i = s.length - 1; i >= 0; i--) {
    if (isNaN(s[i])) break;
    n++;
  }

  return n;
};

Number.prototype.round = function(digits) {
  var factor = Number('1e' + (digits || 0));
  return Math.round(this * factor) / factor;
};

Number.prototype.trunc = function(digits) {
  var re = new RegExp('(-?\\d+\\.\\d{' + digits + '})(\\d)'),
    m = this.toString().match(re);
  return m ? parseFloat(m[1]) : this.valueOf();
};

Date.prototype.ISO = function() {
  return this.getFullYear() + '-' + (this.getMonth() + 1) + '-' + this.getDate();
};

// Casts the JSON object or array to the provided type.
const castJSON = function(json, type) {
  let items = angular.fromJson(json);

  if (angular.isArray(items)) {
    angular.forEach(items, (item, idx) => {
      items[idx] = new (Function.prototype.bind.apply(type, [null, item]))();
    });
  } else if (angular.isObject(items)) {
    items = new (Function.prototype.bind.apply(type, [null, items]))();
  }

  return items;
};

export { castJSON, isGuid };
